import type { SVGProps } from 'react';

const SvgSegmentGoTo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M10 18c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v5c0 .55.45 1 1 1s1-.45 1-1V7c0-1.65-1.35-3-3-3h-4C8.35 4 7 5.35 7 7v10c0 1.65 1.35 3 3 3 .55 0 1-.45 1-1s-.45-1-1-1M20 7c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1s1-.45 1-1V8c0-.55-.45-1-1-1M4 7c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1s1-.45 1-1V8c0-.55-.45-1-1-1"
    />
    <path
      fill="currentcolor"
      d="M16.41 17H17c.55 0 1-.45 1-1s-.45-1-1-1h-3a1.02 1.02 0 0 0-1 1v3c0 .55.45 1 1 1s1-.45 1-1v-.59l2.29 2.29c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41L16.42 17z"
    />
  </svg>
);
export default SvgSegmentGoTo;
